/** Traduções para o datepicker e setar o valor (v-model) como Date */
export const DatePickerDefaultProps = {
    'value-as-date': true,
    'placeholder': "Selecione uma data",
    'label-no-date-selected': "Nenhuma data selecionada",
    'label-help': "Use as setas para navegar pelas datas",
    'label-prev-year': "Ano anterior",
    'label-prev-month': "Mês anterior",
    'label-current-month': "Mês atual",
    'label-next-month': "Próximo mês",
    'label-next-year': "Próximo ano",
    'label-reset-button': "Limpar",
    'date-format-options': { year: 'numeric', month: '2-digit', day: '2-digit' },
}

export const TimePickerDefaultProps = {
    'placeholder': "HH:mm",
    'label-no-time-selected': "Nenhum horário selecionado",
    'show-seconds': false,
    'reset-button': true,
    'label-reset-button': 'Limpar',
    'label-close-button': 'Fechar',
    'locale': 'pt-BR',
    'hourCycle': "h23",
    'hour12': false
}

export const FormGroupDefaultCols = {
    'label-cols': "auto",
    'content-cols': "12"
}

/** 
 * Aqui temos um padrão para configurar inputs number, com html puro, 
 * com casas decimais. este permite 32 casas antes e 4 depois do 
 * separador decimal.
 * */
export const Decimal32dot4Props = {
    'type': "number",
    'min': "0",
    'max': "99999999999999999999999999999999.9999",
    'step': "0.0001"
}
export const Decimal32dot2Props = {
    'type': "number",
    'min': "0",
    'max': "99999999999999999999999999999999.99",
    'step': "0.01"
}

export const MultiSelectDefaultProps = {
    'open-direction': "bottom",
    'close-on-select': true,
    'searchable': true,
    'deselect-label': "",
    'show-labels': false,
    'class': "wrapper-multiselect-sagres",
}